export default "__VITE_ASSET__a11b4bf6__"